import React from 'react';
import Modal from '../../BaseComponents/Modal';

interface UserProfileProps {
  isOpen: boolean;
  onClose: () => void;
}

const UserProfile: React.FC<UserProfileProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title='Profile'>
      User profile
    </Modal>
  );
};

export default UserProfile;
